import { useI18n } from "@/i18n/I18nProvider";

const VendorAgreement = () => {
  const { t, tx } = useI18n();
  const today = new Date().toISOString().slice(0, 10);
  return (
    <div className="container mx-auto px-6 py-12">
      <h1 className="text-3xl font-bold text-gray-900 mb-6">{t('legal.vendor.title', 'Vendor Services Agreement')}</h1>
      <p className="text-gray-700 mb-4">{t('legal.vendor.intro', 'This Vendor Services Agreement governs participation by service providers on the Halomora platform.')}</p>
      <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-3">{t('legal.vendor.h1', '1. Vendor Obligations')}</h2>
      <p className="text-gray-700 mb-4">{t('legal.vendor.p1', 'Vendors must maintain valid licenses and insurance, provide accurate service listings and pricing, and deliver services with reasonable care and skill.')}</p>
      <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-3">{t('legal.vendor.h2', '2. Fees and Payouts')}</h2>
      <p className="text-gray-700 mb-4">{t('legal.vendor.p2', 'Platform fees and payout schedules are determined by Halomora policies.')}</p>
      <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-3">{t('legal.vendor.h3', '3. Limited Payment Collection Agent')}</h2>
      <p className="text-gray-700 mb-4">{t('legal.vendor.p3', 'Vendor appoints Halomora as its limited payments collection agent.')}</p>
      <h3 className="text-lg font-semibold text-gray-900 mt-6 mb-2">{t('legal.vendor.h3b', 'Stripe Connect Onboarding')}</h3>
      <p className="text-gray-700 mb-4">{t('legal.vendor.p3b', 'Halomora may rely on Stripe Connect for payouts.')}</p>
      <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-3">{t('legal.vendor.h4', '4. Compliance')}</h2>
      <p className="text-gray-700 mb-4">{t('legal.vendor.p4', 'Vendors agree to comply with applicable laws and our Acceptable Use Policy.')}</p>
      <p className="text-gray-600 mt-8">{tx('legal.last_updated', { date: today })}</p>
    </div>
  );
};

export default VendorAgreement;
